import { render, staticRenderFns } from "./IncompleteRecordIndicator.vue?vue&type=template&id=2af55507&scoped=true&"
import script from "./IncompleteRecordIndicator.vue?vue&type=script&lang=js&"
export * from "./IncompleteRecordIndicator.vue?vue&type=script&lang=js&"
import style0 from "./IncompleteRecordIndicator.vue?vue&type=style&index=0&id=2af55507&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af55507",
  null
  
)

export default component.exports